<template>
  <div id="windy"></div>
</template>

<script>
import {WindyHandler} from '@/utils/windy.js';
import {PointsStore} from "@/store";
import {storeToRefs} from 'pinia';
import constants from "@/consts";

export default {
  name: "WindyMap",
  setup() {
    const points_store = PointsStore();
    const {focused_point, gateways_countries, device_visibility, device_points} = storeToRefs(points_store);
    return {points_store, focused_point, gateways_countries, device_visibility, device_points};
  },
  data() {
    return {
      windy_handler: null,
      constants,
    }
  },
  async mounted() {
    const devices_data = this.points_store.devices.map(device => ({
      slug: device.slug,
      color: this.points_store.get_device_color(device.slug),
      points: (this.points_store.device_points[device.slug] || []).filter(
          point => point.latitude != null && point.latitude !== '' && point.longitude != null && point.longitude !== ''
      )
    }));

    const all_points = devices_data.flatMap(d => d.points);
    this.windy_handler = new WindyHandler(all_points);
    this.windy_handler.init_windy_map(this.points_store.gates, devices_data);
  },
  watch: {
    focused_point(new_point) {
      if (this.windy_handler !== null && new_point !== undefined && new_point.latitude != null && new_point.latitude !== '' && new_point.longitude != null && new_point.longitude !== '') {
        this.windy_handler.change_map_center(new_point);
      }
    },
    gateways_countries(countries) {
      if (this.windy_handler !== null) {
        this.windy_handler.delete_lora_gateway_clusters();
        let selected_countries = countries.map(country => country.alpha2.toLowerCase());
        let gates = this.points_store.filter_gates(selected_countries);
        this.windy_handler.create_lora_gateway_clusters(gates);
      }
    },
    device_visibility: {
      deep: true,
      handler(visibility) {
        if (this.windy_handler === null) return;
        for (const device of this.points_store.devices) {
          this.windy_handler.set_device_visibility(device.slug, visibility[device.slug]);
        }
      }
    },
    device_points: {
      deep: true,
      handler(new_points) {
        if (this.windy_handler === null) return;
        for (const device of this.points_store.devices) {
          const points = (new_points[device.slug] || []).filter(
              p => p.latitude != null && p.latitude !== '' && p.longitude != null && p.longitude !== ''
          );
          const color = this.points_store.get_device_color(device.slug);
          this.windy_handler.update_device_path(device.slug, points, color);
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
#windy {
  width: 100%;
  height: 100vh;
}
.leaflet-marker-icon {
  color: white;
  font-weight: bold;
}
>>> #windy #logo {
  transform: scale(0.2, 0.2) !important;
  margin-top: 0 !important;
}
</style>
